export default __webpack_public_path__ + "static/media/eurostyle_normal.484dfcab.ttf";